export const GET_SIZE = "GET_SIZE";
export const GET_SIZE_SUCCESS = "GET_SIZE_SUCCESS";
export const GET_SIZE_ERROR = "GET_SIZE_ERROR";
